import React from 'react';
import { useT } from './BuilderApp.jsx';

export default function BuildErrorScreen({ buildError, onBack }) {
  const t = useT();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', position: 'relative', zIndex: 1, textAlign: 'center' }}>
      <div style={{ maxWidth: 440, width: '100%' }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️</div>
        <h2 style={{ fontSize: '1.4rem', fontWeight: 800, marginBottom: '.6rem' }}>{t.err_title}</h2>
        <div style={{ background: 'rgba(248,113,113,.08)', border: '1px solid rgba(248,113,113,.2)', borderRadius: 12, padding: '1rem', marginBottom: '1.5rem', fontSize: '.85rem', color: '#f87171' }}>
          {buildError}
        </div>
        <button className="btn btn-ghost btn-full" onClick={onBack}>{t.err_back}</button>
      </div>
    </div>
  );
}
